import moment from 'moment-timezone';

const formatName = (str: string): string => str.replace(/_/g, ' ');

/**
 * "America/New_York" -> "America - New York (EST)"
 * "America/Indiana/Indianapolis" -> "America - Indianapolis, Indiana (EST)"
 */
export const getTimezoneLabel = (tzId: string): string => {
  const abbr = moment.tz(tzId).zoneAbbr();
  const parts = tzId.split('/');
  const region = parts[0];

  // 3+ parts means state is present (e.g., America/Indiana/Indianapolis)
  if (parts.length >= 3) {
    const state = formatName(parts[1]);
    const city = formatName(parts[2]);
    return `${region} - ${city}, ${state} (${abbr})`;
  }
  // 2 parts means city is present (e.g., America/New_York)
  if (parts.length === 2) {
    const city = formatName(parts[1]);
    return `${region} - ${city} (${abbr})`;
  } else {
    return `${region} (${abbr})`;
  }
};
